module.exports = __webpack_public_path__ + "assets/img/SomehowThePrompt_img.8bdf0aa8.png";